import { atom } from 'jotai';

import { type HelpdeskData } from '@/features/user/types/helpdesk-types';

export const helpdeskDataAtom = atom<HelpdeskData | null>(null);
